import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { IconCircleXFilled } from '@tabler/icons-react';
import { useState } from 'react';

const TableSearchInput = ({ onSearch }) => {
    const [searchText, setSearchText] = useState('');

    const handleChange = (event) => {
        setSearchText(event.target.value);
        if (onSearch) {
            onSearch(event.target.value);
        }
    };

    const handleClear = () => {
        setSearchText('');
        if (onSearch) {
            onSearch('');
        }
    };

    return (
        <FormControl size="small" variant="outlined" fullWidth>
            <InputLabel htmlFor="search-input" >검색</InputLabel>
            <OutlinedInput
                id="search-input"
                name="search-input"
                type="text"
                value={searchText}
                onChange={handleChange}
                label="검색"
                fullWidth
                endAdornment={
                    <InputAdornment position="end">
                        {searchText ? (
                            <IconButton
                                sx={{ padding: '0', margin: '0' }}
                                onClick={handleClear}  >
                                <IconCircleXFilled size={'1.2rem'} />
                            </IconButton>
                        ) : <div style={{ visibility: 'hidden', fontSize: '1.2rem' }}>ㅇ</div>
                        }
                    </InputAdornment>
                }
            />
        </FormControl>
    );
};

export default TableSearchInput;
